module.exports = __webpack_public_path__ + "static/media/Checkmark.68d5c963.svg";